// extracted by mini-css-extract-plugin
export var container = "FullScreenLoader-module--container--90e06";
export var loader = "FullScreenLoader-module--loader--b794f";